import config from './config/api.js'
import Axios from 'axios'
import store from './store/index.js'

const userLogin = async function (userName, password) {
  var setting = config.users.login
  var data = {
    userName: userName,
    password: password
  }
  var result = await callApi(setting.method, setting.url, data)
  return result
}
const createUserGroups = async function (name) {
  var setting = config.userGroups.create
  var data = {
    name: name,
    permission: 0
  }
  var result = await callApi(setting.method, setting.url, data)
  return result
}

const getUserGroups = async function () {
  var setting = config.userGroups.list
  var data = {
    offset: 0,
    limit: 50
  }
  var result = await callApi(setting.method, setting.url, data)
  return result
}

const updateUserGroups = async function (id, name) {
  var setting = config.userGroups.update
  var data = {
    name: name,
    permission: 0
  }
  var result = await callApi(setting.method, setting.url + "/" + id, data)
  return result
}

const deleteUserGroups = async function (id) {
  var setting = config.userGroups.delete
  var result = await callApi(setting.method, setting.url + "/" + id)
  return result
}

const createUser = async function (data) {
  var setting = config.users.create
  var result = await callApi(setting.method, setting.url, data)
  return result
}

const updateUser = async function (id, data) {
  var setting = config.users.update
  // var data = {
  //   name: name,
  //   permission: 0
  // }
  var result = await callApi(setting.method, setting.url + "/" + id, data)
  return result
}

const deleteUser = async function (id) {
  var setting = config.users.delete
  var result = await callApi(setting.method, setting.url + "/" + id)
  return result
}

const getUserList= async function () {
  var setting = config.users.list
  var data = {
    offset: 0,
    limit: 50
  }
  var result = await callApi(setting.method, setting.url, data)
  return result
}

const getItmeList= async function (data) {
  var setting = config.items.list
  var result = await callApi(setting.method, setting.url, data)
  return result
}

const createItem = async function (data) {
  var setting = config.items.create
  var result = await callApi(setting.method, setting.url, data)
  return result
}

const itemUpload = async function (id) {
  var setting = config.items.upload
  var result = await callApi(setting.method, setting.url + "/" + id)
  return result
}

const deleteItem = async function (id) {
  var setting = config.items.delete
  var result = await callApi(setting.method, setting.url + "/" + id)
  return result
}

const createGoods = async function (data) {
  var setting = config.goods.create
  var result = await callApi(setting.method, setting.url, data)
  return result
}

const deleteGoods = async function (id) {
  var setting = config.goods.delete
  var result = await callApi(setting.method, setting.url + "/" + id)
  return result
}

const getGoodsList = async function (data) {
  var setting = config.goods.list
  var sendData = { limit: data.limit, offset: data.offset }
  var column = ''
  switch (data.column) {
    case 'name':
      column = 'name'
    break;
    case 'goodsNumber':
      column = 'goods_number'
    break;
    case 'itemNumber':
      column = 'item_number'
    break;
    default:
      column = ''
    break;
  }
  if (data.value !== '') sendData[column] = data.value
  var result = await callApi(setting.method, setting.url, sendData)
  return result
}

const categoryList = async function (data) {
  var setting = config.categories.list
  var result = await callApi(setting.method, setting.url, data)
  return result
}

const createCategory = async function (data) {
  var setting = config.categories.create
  var result = await callApi(setting.method, setting.url, data)
  return result
}

const updateCategory = async function (id, data) {
  var setting = config.categories.update
  var result = await callApi(setting.method, setting.url + "/" + id, data)
  return result
}

const deleteCategory = async function (id) {
  var setting = config.categories.delete
  var result = await callApi(setting.method, setting.url + "/" + id)
  return result
}

const getSaleGroup = async function (saleGroupId) {
  var setting = config.saleGroups.get
  var url = setting.url.replace('{{saleGroupId}}', saleGroupId)
  var result = await callApi(setting.method, url)
  return result
}

const getSaleGroupList = async function (data) {
  var setting = config.saleGroups.list
  var result = await callApi(setting.method, setting.url, data)
  return result
}

const createSaleGroup = async function (data) {
  var setting = config.saleGroups.create
  var result = await callApi(setting.method, setting.url, data)
  return result
}

const updateSaleGroup = async function (id, data) {
  var setting = config.saleGroups.update
  var result = await callApi(setting.method, setting.url + "/" + id, data)
  return result
}

const getStuffList = async function (saleGroupId) {
  var setting = config.stuff.list
  var data = {
    offset: 0,
    limit: 50
  }
  var url = setting.url.replace('{{saleGroupId}}', saleGroupId)
  var result = await callApi(setting.method, url, data)
  return result
}

const createStuff = async function (saleGroupId, data) {
  var setting = config.stuff.create
  var url = setting.url.replace('{{saleGroupId}}', saleGroupId)
  var result = await callApi(setting.method, url, data)
  return result
}

const updateStuff = async function (saleGroupId, id, data) {
  var setting = config.stuff.update
  var url = setting.url.replace('{{saleGroupId}}', saleGroupId)
  var result = await callApi(setting.method, url + "/" + id, data)
  return result
}

const deleteStuff = async function (saleGroupId, id) {
  var setting = config.stuff.delete
  var url = setting.url.replace('{{saleGroupId}}', saleGroupId)
  var result = await callApi(setting.method, url + "/" + id)
  return result
}


//==================================
const getBannerList = async function (data) {
  var setting = config.banners.list
  var result = await callApi(setting.method, setting.url, data)
  return result
}

const createBanner = async function (data) {
  var setting = config.banners.create
  var result = await callApi(setting.method, setting.url, data)
  return result
}

const updateBanner = async function (bannerId, data) {
  var setting = config.banners.update
  var result = await callApi(setting.method, setting.url + "/" + bannerId, data)
  return result
}

const deleteBanner = async function (id) {
  var setting = config.banners.delete
  var result = await callApi(setting.method, setting.url + "/" + id)
  return result
}

//===================================
const getSalePageList = async function (saleGroupId, data) {
  var setting = config.salePages.list
  var url = setting.url.replace('{{saleGroupId}}', saleGroupId)
  var result = await callApi(setting.method, url, data)
  return result
}

const createSalePage = async function (saleGroupId, data) {
  var setting = config.salePages.create
  var url = setting.url.replace('{{saleGroupId}}', saleGroupId)
  var result = await callApi(setting.method, url, data)
  return result
}

const updateSalePage = async function (saleGroupId, id, data) {
  var setting = config.salePages.update
  var url = setting.url.replace('{{saleGroupId}}', saleGroupId)
  var result = await callApi(setting.method, url + "/" + id, data)
  return result
}

const deleteSalePage = async function (saleGroupId, id) {
  var setting = config.salePages.delete
  var url = setting.url.replace('{{saleGroupId}}', saleGroupId)
  var result = await callApi(setting.method, url + "/" + id)
  return result
}

//===============================
const getCurrencyList = async function (data) {
  var setting = config.currencies.list
  var result = await callApi(setting.method, setting.url, data)
  return result
}

const createCurrency = async function (data) {
  var setting = config.currencies.create
  var result = await callApi(setting.method, setting.url, data)
  return result
}

const updateCurrency = async function (id, data) {
  var setting = config.currencies.update
  var result = await callApi(setting.method, setting.url + "/" + id, data)
  return result
}

const deleteCurrency = async function (id) {
  var setting = config.currencies.delete
  var result = await callApi(setting.method, setting.url + "/" + id)
  return result
}

//=================================

const getStoreList = async function (data) {
  var setting = config.stores.list
  var result = await callApi(setting.method, setting.url, data)
  return result
}

const getStore = async function (id) {
  var setting = config.stores.get
  var result = await callApi(setting.method, setting.url + "/" + id)
  return result
}

const updateStore = async function (id, data) {
  var setting = config.stores.update
  var result = await callApi(setting.method, setting.url + "/" + id, data)
  return result
}
//====================================


const getBranchList = async function (data) {
  var setting = config.branches.list
  var result = await callApi(setting.method, setting.url, data)
  return result
}

const createBranch = async function (data) {
  var setting = config.branches.create
  var result = await callApi(setting.method, setting.url, data)
  return result
}

const updateBranch = async function (id, data) {
  var setting = config.branches.update
  var result = await callApi(setting.method, setting.url + "/" + id, data)
  return result
}
//====================================

const getAddpurchaseList = async function (data) {
  var setting = config.addpurchases.list
  var result = await callApi(setting.method, setting.url, data)
  return result
}

const createAddpurchase = async function (data) {
  var setting = config.addpurchases.create
  var result = await callApi(setting.method, setting.url, data)
  return result
}

const updateAddpurchase = async function (id, data) {
  var setting = config.addpurchases.update
  var result = await callApi(setting.method, setting.url + "/" + id, data)
  return result
}
//====================================

const uploadImage = async function (prefix, file) {
  var setting = config.imageUpload
  return Axios({
    method: setting.method,
    url: setting.url + "/" + prefix,
    data: file,
    headers: {
      'Content-Type': 'binary/octet-stream'
    }
  }).then(function(res){
    return res.data
  }).catch(function(error){
    return error.data
  })
}

//===================================
const getPlanList = async function (saleGroupId, data) {
  var setting = config.plans.list
  var data = {
    offset: 0,
    limit: 50
  }
  var url = setting.url.replace('{{saleGroupId}}', saleGroupId)
  var result = await callApi(setting.method, url, data)
  return result
}

const createPlan = async function (saleGroupId, data) {
  var setting = config.plans.create
  var url = setting.url.replace('{{saleGroupId}}', saleGroupId)
  var result = await callApi(setting.method, url, data)
  return result
}

const updatePlan = async function (saleGroupId, id, data) {
  var setting = config.plans.update
  var url = setting.url.replace('{{saleGroupId}}', saleGroupId)
  var result = await callApi(setting.method, url + "/" + id, data)
  return result
}

const deletePlan = async function (saleGroupId, id) {
  var setting = config.plans.delete
  var url = setting.url.replace('{{saleGroupId}}', saleGroupId)
  var result = await callApi(setting.method, url + "/" + id)
  return result
}

//=========== languages =============
const getAvailableLanguages = async function() {
  var setting = config.languages.available
  var result = await callApi(setting.method, setting.url)
  return result
}
const getSupportedLanguages = async function() {
  var setting = config.languages.supported
  var result = await callApi(setting.method, setting.url)
  return result
}

const createSupportedLanguage = async function(data) {
  var setting = config.languages.create
  var result = await callApi(setting.method, setting.url, data)
  return result
}
//=============================================

const getOrderList = async function(data) {
  var setting = config.orders.list
  var result = await callApi(setting.method, setting.url, data)
  return result
}

const updateOrder = async function(id, data) {
  var setting = config.orders.update
  var result = await callApi(setting.method, setting.url + "/" + id, data)
  return result
}

const checkOrders = async function(action) {
  var setting = config.orders.check
  var result = await callApi(setting.method, setting.url, action)
  return result
}

const returnOrder = async function(orderId, data) {
  var setting = config.orders.return
  var url = setting.url.replace('{{orderId}}', orderId)
  var result = await callApi(setting.method, url, data)
  return result
}

const issueInvoice = async function(orderId) {
  var setting = config.orders.issueInvoice
  var url = setting.url.replace('{{orderId}}', orderId)
  var result = await callApi(setting.method, url)
  return result
}

const cancelInvoice = async function(orderId) {
  var setting = config.orders.cancelInvoice
  var url = setting.url.replace('{{orderId}}', orderId)
  var result = await callApi(setting.method, url)
  return result
}

const createAllowance = async function(orderId, data) {
  var setting = config.orders.createAllowance
  var url = setting.url.replace('{{orderId}}', orderId)
  var result = await callApi(setting.method, url, data)
  return result
}

const batchChangeStatus = async function(data) {
  var setting = config.orders.batchChangeStatus
  var result = await callApi(setting.method, setting.url, data)
  return result
}

//===================================

const callApi = function (method, url, sendData = {}) {
  var data = JSON.parse(JSON.stringify(sendData))
  Object.keys(data).forEach(key => (data[key] === undefined) ? delete data[key] : null)
  if (method == 'get' && Object.keys(data).length > 0) {
    Object.keys(data).forEach(key => (data[key] === null || data[key] === '') ? delete data[key] : null)
    var queryArr = []
    for (let elem in data) {
      queryArr.push(`${elem}=${data[elem]}`)
    }
    url = url + "?" + queryArr.join('&')
  }
  return Axios({
    method: method,
    url: url,
    data: data
    // headers: {
    //   'Access-Control-Allow-Origin': '*'
    //   // 'Authorization': 'Bearer '
    // }
  }).then(function(res){
    return res.data
  }).catch(function(error){
    return error.data
  })
}

const clearEmpties = (o) => {
  for (var k in o) {
    if (!o[k] || typeof o[k] !== "object") {
      continue // If null or not an object, skip to the next iteration
    }

    if (Object.keys(o[k]) === '') {
      delete o[k]; // The object had no properties, so delete that property
    }
    // The property is an object
    if (Object.keys(o[k]).length === 0) {
      delete o[k]; // The object had no properties, so delete that property
    }
  }
}

const JSONtoCSV = (arr, columns, delimiter = ',') =>
  [
    columns.join(delimiter),
    ...arr.map(obj =>
      columns.reduce(
        (acc, key) => `${acc}${!acc.length ? '' : delimiter}"${!obj[key] ? '' : !Array.isArray(obj[key]) ? obj[key] : obj[key].join('\n')}"`,
        ''
      )
    )
  ].join('\n')

const getCurrentUser = async function () {
  var data = {
    UserPoolId: process.env.COGNITO_USER_POOL_ID,
    ClientId: process.env.COGNITO_CLIENT_ID
  }
  var userPool = new CognitoUserPool(data)
  var cognitoUser = userPool.getCurrentUser()
  if (cognitoUser != null) {
    cognitoUser.getSession(function (err, session) {
      if (err) {
        alert(err)
        return null
      }
      console.log('session validity: ' + session.isValid())
      var idToken = session.idToken.jwtToken
      var role = session.getIdToken().decodePayload()['custom:role']
      var user = { token: idToken, role: role }
      return user
    })
  } else {
    return null
  }
}

const getUser = function () {
  return JSON.parse(store.state.user)
}

const logout = function () {
  store.commit('del_user')
}

export default {
  callApi: callApi,
  userLogin: userLogin,
  updateUserGroups: updateUserGroups,
  getUserGroups: getUserGroups,
  createUserGroups: createUserGroups,
  deleteUserGroups: deleteUserGroups,

  getUser: getUser,
  getUserList: getUserList,
  createUser: createUser,
  updateUser: updateUser,
  deleteUser: deleteUser,

  createItem: createItem,
  getItmeList: getItmeList,

  getGoodsList: getGoodsList,
  createGoods: createGoods,
  deleteGoods: deleteGoods,

  categoryList: categoryList,
  createCategory: createCategory,
  updateCategory: updateCategory,
  deleteCategory: deleteCategory,

  getSaleGroup: getSaleGroup,
  getSaleGroupList: getSaleGroupList,
  createSaleGroup: createSaleGroup,
  updateSaleGroup: updateSaleGroup,

  getStuffList: getStuffList,
  createStuff: createStuff,
  updateStuff: updateStuff,
  deleteStuff: deleteStuff,

  getBannerList: getBannerList,
  createBanner: createBanner,
  updateBanner: updateBanner,
  deleteBanner: deleteBanner,

  getSalePageList: getSalePageList,
  createSalePage: createSalePage,
  updateSalePage: updateSalePage,

  getCurrencyList: getCurrencyList,
  createCurrency: createCurrency,
  updateCurrency: updateCurrency,

  getStore: getStore,
  updateStore: updateStore,
  getStoreList: getStoreList,

  getBranchList: getBranchList,
  updateBranch: updateBranch,
  createBranch: createBranch,

  getAddpurchaseList: getAddpurchaseList,
  updateAddpurchase: updateAddpurchase,
  createAddpurchase: createAddpurchase,

  uploadImage: uploadImage,

  getPlanList: getPlanList,
  createPlan: createPlan,
  updatePlan: updatePlan,
  deletePlan: deletePlan,

  getAvailableLanguages: getAvailableLanguages,
  getSupportedLanguages: getSupportedLanguages,
  createSupportedLanguage: createSupportedLanguage,

  getOrderList: getOrderList,
  updateOrder: updateOrder,
  checkOrders: checkOrders,
  returnOrder: returnOrder,
  issueInvoice: issueInvoice,
  cancelInvoice: cancelInvoice,
  createAllowance: createAllowance,
  batchChangeStatus: batchChangeStatus,

  JSONtoCSV: JSONtoCSV,
  itemUpload: itemUpload,
  deleteItem: deleteItem,
  logout: logout

}
